import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import AuthService from "services/auth.service";

let currentUser = AuthService.getCurrentUser();

class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  getDashboardLink() {
    const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";
    const isHealthlane = currentUser?.role.includes("healthlane");

    const productionUrl = isHealthlane
      ? "https://admin-v2.bookdoc.com/analytic/public/dashboard/f94a344f-feea-488e-a2c6-c51edcb2b6d2"
      : "https://admin-v2.bookdoc.com/analytic/public/dashboard/0162756e-810c-47c7-9ced-b8b81e0f49ff";

    const qaUrl = isHealthlane
      ? "https://qa-api.bookdoc.com/metabase/public/dashboard/37b4d876-f783-4e6a-960f-53fa749e0404"
      : "https://qa-api.bookdoc.com/metabase/public/dashboard/4527b4a7-e44f-4952-af9d-1ab5bba5f59b";

    return isProduction ? productionUrl : qaUrl;
  }

  render() {
    if (currentUser?.role === "caring_store_admin") {
      return <Navigate to="/admin/dashboard" />;
    }
    return (
      <div className="admin-page">
        <h4 className="mb-4 fw-bold">Statistics</h4>

        <div id="statistic-content">
          <iframe
            src={this.getDashboardLink()}
            width="100%"
            height="650px"
            title="statistic"
          ></iframe>
        </div>
      </div>
    );
  }
}

export { Statistics };
